import { Button } from "@material-ui/core";
import ReactExport from "react-export-excel";
import { useTranslation } from "react-i18next";

export default function ExcelDownloadButton(props) {
    const {t} = useTranslation('common');

    const { rows, name, classes } = props;

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    return (
        <>
            {
                (rows?.length > 0) ?
                <ExcelFile
                    element={
                        <Button
                            color='secondary'
                            variant="contained"
                            className={classes.excelMargin}
                        >
                            {t('download')}
                        </Button>
                    }
                >
                    <ExcelSheet data={rows} name={name}>
                        {
                            Object.keys(rows[0]).map((key) => (
                                <ExcelColumn label={key} value={key}/>
                            ))
                        }
                    </ExcelSheet>
                </ExcelFile>
                :
                <Button
                    variant="contained"
                    disabled
                    className={classes.excelMargin}
                >
                    {t('download')}
                </Button>
            }
        </>
    );
}

ExcelDownloadButton.defaultProps = {
    rows: [],
    name: '',
    classes: {}
}